import { createContext } from 'react';
import { MenuActionControlProviderContextType } from '#baseMenu/contexts';

const MenuActionControlProviderContext = createContext<MenuActionControlProviderContextType>(null);

export { MenuActionControlProviderContext };
